module.exports = __webpack_public_path__ + "img/10blue.6b7d7fc4.png";